// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// vendor components
import '@/services/firebase-init'
import App from './App'
import ArgonDashboardPlugin from '@/libs/vue-argon-dashboard-pro-master/src/plugins/dashboard-plugin'
import router from './router'
import VS2 from 'vue-script2'
import { BootstrapVue } from 'bootstrap-vue'
import Icon from 'vue-awesome/components/Icon'
import Spreadsheet from '@/components/Spreadsheet'
import store from '@/store'
import Vuelidate from 'vuelidate'
import { codemirror } from 'vue-codemirror'
import InputTag from 'vue-input-tag'
import { abilitiesPlugin } from '@casl/vue'
import { mapState } from 'vuex'
import Vue2Filters from 'vue2-filters'
import VueDraggableResizable from 'vue-draggable-resizable'
import VueNumerals from 'vue-numerals'
import Fragment from 'vue-fragment'
import VueSlider from 'vue-slider-component'
import DatePicker from 'vuejs-datepicker'
import alasqlJs from 'alasql'
import SlimDialog from 'v-slim-dialog'
import collectjs from 'collect-js'
import Multiselect from 'vue-multiselect'
import { Route, RouterLink } from 'vue-component-router'
import directives from '@/directives'
import VueSignaturePad from 'vue-signature-pad'
import Mindmap from 'vue-mindmap'
import Paginate from 'vuejs-paginate'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import VueFlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import cookie from 'js-cookie'
import VueSlimScroll from 'vue-slimscroll'
import 'vue-search-select/dist/VueSearchSelect.css'
import axios from 'axios'

// import libs
import '@/libs'
import './libs/frontwise-editor/frontwise.js'
import './libs/frontwise-editor/frontwise.css'


// helpers

// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'vue-mindmap/dist/vue-mindmap.css'

import 'vue-orgchart/dist/style.min.css'
import 'vue-orgchart'
import 'vue-loaders/dist/vue-loaders.css';
import VueLoaders from 'vue-loaders';

// custom components
import NavBar from '@/components/NavBar'
import PivotTable from '@/components/PivotTable'
import PostsWidget from '@/components/Posts/PostsWidget'
import JsonEditor from '@/components/JsonEditor'
import DataGrid from '@/components/DataGrid'
import Chart from '@/components/Chart'
import GanttChart from '@/components/GanttChart'
import GanntSimple from '@/components/GanntSimple'
import ChartOnly from '@/components/Chart/ChartOnly.vue'
import PivotGrid from '@/components/PivotGrid/PivotAll'
import DataTreePicker from '@/components/DataTreePicker'
import FullCalendar from '@/components/FullCalendar'
import DataGridEditRow from '@/components/DataGrid/EditRow'
import Chat from '@/components/BeautifulChat'
import HandyScroll from '@/components/HandyScroll'
import TipTapEditor from '@/components/TipTapEditor'

import Kanban from '@/components/Kanban'
import Diagram from '@/components/Diagram'
import MinimalUI from '@/components/minimal-ui'
import WorkflowButtons from '@/components/WorkflowButtons'
import SimpleWorkflow from '@/components/SimpleWorkflow'

import excel from 'vue-excel-export'

import OrganizationChart from 'vue-organization-chart'
import 'vue-organization-chart/dist/orgchart.css'

import VueWorker from 'vue-worker'

alasqlJs.options.cache = false
const alasql = {
  install(v) {
    Vue.prototype.alasql = alasqlJs
  },
}
window.collect = collectjs

import utils from '@/helpers/utils/index.js'
import AuthStatusCheck from '@/helpers/auth-status-check'
import 'v-slim-dialog/dist/v-slim-dialog.css'
import _ from 'underscore'

import Treeselect from '@riophae/vue-treeselect'
// import the styles
import 'element-ui/lib/theme-chalk/index.css'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { functions } from 'firebase'

import VueQr from 'vue-qr'
import JsonCSV from 'vue-json-csv'
import VueClipboard from 'vue-clipboard2'
import Notifications from 'vue-notification'
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from "vue-qrcode-reader";

Vue.config.productionTip = false
 
VueClipboard.config.autoSetContainer = true // add this line

Vue.use(VueClipboard)
Vue.use(Notifications)
Vue.use(Route)
Vue.use(ArgonDashboardPlugin)
Vue.use(RouterLink)
Vue.use(BootstrapVue)
Vue.use(VS2)
Vue.use(Vuelidate)
Vue.use(abilitiesPlugin)
Vue.use(Vue2Filters, 'filterBy')
Vue.use(VueNumerals, { locale: 'en-au' })
Vue.use(JsonEditor)
Vue.use(require('vue-moment'))
Vue.use(Fragment.Plugin)
Vue.use(DataTreePicker)
Vue.use(alasql)
Vue.use(SlimDialog)
Vue.use(VueSignaturePad)
Vue.use(Mindmap)
Vue.use(MinimalUI)
Vue.use(ElementUI, { locale })
Vue.use(VueFlatPickr)
Vue.use(Chat)
Vue.use(excel)
Vue.use(VueWorker)
Vue.use(VueSlimScroll)
Vue.use(VueLoaders);

// components registration
Vue.component('NavBar', NavBar)
Vue.component('downloadCsv', JsonCSV)
Vue.component('icon', Icon)
Vue.component('Spreadsheet', Spreadsheet)
Vue.component('input-tag', InputTag)
Vue.component('PivotTable', PivotTable)
Vue.component('PostsWidget', PostsWidget)
Vue.component('vue-draggable-resizable', VueDraggableResizable)
Vue.component('codemirror', codemirror)
Vue.component('DataGrid', DataGrid)
Vue.component('Chart', Chart)
Vue.component('ChartOnly', ChartOnly)
Vue.component('GanttChart', GanttChart)
Vue.component('GanntSimple', GanntSimple)
Vue.component('TipTapEditor', TipTapEditor)
Vue.component('PivotGrid', PivotGrid)
Vue.component('VueSlider', VueSlider)
Vue.component('DatePicker', DatePicker)
Vue.component('multiselect', Multiselect)
Vue.component('FullCalendar', FullCalendar)
Vue.component('DataGridEditRow', DataGridEditRow)
Vue.component('OrganizationChart', OrganizationChart)

Vue.component('Kanban', Kanban)
Vue.component('Diagram', Diagram)
Vue.component('WorkflowButtons', WorkflowButtons)
Vue.component('Treeselect', Treeselect)
Vue.component('paginate', Paginate)
Vue.component('HandyScroll', HandyScroll)
Vue.component('vue-qr', VueQr)
Vue.component('qrcode-stream', QrcodeStream)
Vue.component('SimpleWorkflow', SimpleWorkflow)


// set utils to vue instance
for (let utilName in utils) {
  Vue.prototype['$' + utilName] = utils[utilName]
}
Vue.prototype.$cookie = cookie
Vue.prototype.$axios = axios
// set directives to vue instance
for (let directive in directives) {
  Vue.directive(directive, directives[directive])
}

/* eslint-disable no-new */
Vue.prototype.$suggestions = {name:'test'}

Vue.prototype.$popupRes = function(res) {
  const { title, message, variant } = res

  this.$bvToast.toast(message, {
    title,
    variant,
    solid: true,
    toaster: 'b-toaster-top-center',
    autoHideDelay: 2500,
  })
}

export const appInst = new Vue({
  el: '#app',
  router,
  store,
  validations: {},
  components: {
    App,
    Icon,
    Spreadsheet,
    codemirror,
  },
  template: '<App/>',
  computed: {
    ...mapState(['caslRules'])
  },
  created() {
    this.$ability.update(this.caslRules)

    this.$store.watch(
      state => {
        return state.caslRules
      },
      newRules => {
        this.$ability.update(Object.values(newRules))
      }
    )

    new AuthStatusCheck(this.$store, this.$router)
  },
})
